import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {


  constructor(private http: HttpClient) { }

  checkStatus() {
    return this.http.get<{ maintenance_state }>('/edozzier/portal-get-maintenance-state.php');

  }
}
